import { StyledIconGlass } from './IconGlass.styled';

const IconGlass = () => {
  return <StyledIconGlass />;
};

export default IconGlass;
